import React, { useContext } from 'react';
import logo from './../../assets/donna.png';
import { makeStyles } from '@material-ui/core/styles';
import { UserContext } from '../UserContext';
import agencyIQLogo from './../../assets/agencyIQ_Logo.png';

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: 50,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    height: '100%',
  },
  logo: {
    height: 32,
  },
  logoAlt: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
}));

export function AppLogo() {
  const classes = useStyles();
  const { user } = useContext(UserContext);
  const isSiaaAgency = user.isSiaaAgency();

  return (
    <div className={classes.root}>
      <div className={classes.logoAlt}>
        <img
          className={classes.logo}
          src={isSiaaAgency ? agencyIQLogo : logo}
          alt="logo"
        />
      </div>
    </div>
  );
}
